module.exports = __webpack_public_path__ + "static/media/fercam.eb54ba85.webp";